import Dispatcher from '../dispatcher';
import { VoucherCodeLightBoxActions } from '../constants/voucher_code_light_box/voucher_code_light_box_actions';
import { close, open } from '../../_modules/google_analytics/voucher_code_light_box';
import getTranslatedText from '../helper/get_translated_text';

function show(payload) {
  open();
  Dispatcher.handleVoucherCodeLightboxAction({
    type: VoucherCodeLightBoxActions.SHOW,
    payload,
  });
}

function hide() {
  close();
  Dispatcher.handleVoucherCodeLightboxAction({
    type: VoucherCodeLightBoxActions.HIDE,
  });
}

function update(payload) {
  Dispatcher.handleVoucherCodeLightboxAction({
    type: VoucherCodeLightBoxActions.UPDATE,
    payload,
  });
}

function invalidAction(invalidMessage) {
  Dispatcher.handleVoucherCodeLightboxAction({
    type: VoucherCodeLightBoxActions.INVALID_ACTION,
    payload: invalidMessage || getTranslatedText('message-voucher-invalid'),
  });
}

function validAction(validMessage) {
  Dispatcher.handleVoucherCodeLightboxAction({
    type: VoucherCodeLightBoxActions.VALID_ACTION,
    payload: validMessage || getTranslatedText('message-voucher-success'),
  });
}

function addLoadingAction() {
  Dispatcher.handleVoucherCodeLightboxAction({
    type: VoucherCodeLightBoxActions.ADD_LOADING,
  });
}

function removeLoadingAction() {
  Dispatcher.handleVoucherCodeLightboxAction({
    type: VoucherCodeLightBoxActions.REMOVE_LOADING,
  });
}

function updateCodeAction(code) {
  Dispatcher.handleVoucherCodeLightboxAction({
    type: VoucherCodeLightBoxActions.UPDATE_CODE,
    payload: code,
  });
}

export { show, hide, update, invalidAction, validAction, addLoadingAction, removeLoadingAction, updateCodeAction };
